import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The console type scale, declared to tailwind-merge as font sizes.
 *
 * `text-*` is two class groups wearing one prefix - a size and a colour - and
 * tailwind-merge tells them apart from a list of the sizes it knows. A name it has
 * not been told about is assumed to be a colour, so without this `text-meta` and
 * `text-dim` cancelled each other out: the last one written won and half the
 * pairings in the app silently lost either their size or their colour.
 *
 * Keep this in step with the `--text-*` tokens in the dashboard's globals.css.
 */
const TYPE_SCALE = ['nano', 'micro', 'meta', 'body', 'lede', 'title'];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: TYPE_SCALE }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
